<template>
  <el-dialog
      :visible.sync="showAddDoctor"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div class="dialog-main-content">
        <div style="margin-right: 10px">
          <div slot="title">
            <h1 class="dialog-title">选择医生团队</h1>
          </div>
          <!-- 查询条件 -->
          <div class="pat-search">
            
            <el-input v-model="listQuery['keyword']" placeholder="请输入医生团队名称/所属机构" clearable size="mini"></el-input>
            <el-button size="mini" @click="resetForm">重置</el-button>
            <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
          </div>
          <div class="main-content-list">
            <el-table :data="tableData" style="width: 100%;" :header-cell-style="{
              background:'#FAFAFA',
              fontWeight: 'bold',
              color: '#333333',
              fontSize:'14px'
            }">
              
              <el-table-column
                prop="name"
                label="医生团队"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="hospitalName"
                label="所属机构"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="memberName"
                label="团队成员"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="handleAdd(scope.row)"
                    type="text"
                    size="small"
                  >
                    选用
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div
            class="cardpage"
            style="text-align: right; margin-right: 30px; margin-top: 30px"
          >
            <el-pagination
              background
              :current-page="listQuery.current"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="listQuery.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"/>
          </div>
        </div>
      </div>
    </el-dialog>
</template>
<script>
import { doctorTeamSearch } from "../api/index"

export default {
  props: {
    showAddDoctor: {
      type: Boolean
    },
    belongDataList:{
      type:Array,
      default:[]
    }
    // topHospitalId: {
    //   type: String
    // },
    
  },
  watch: {
    showAddDoctor(val) {
      this.visible = val
      if (val) {
        this.getInitData()
      }
    },
    
  },
  data() {
    return {
      paperId: '',
      visible: false,
      questionnaireList: [],
      questionTypeList: [],
      name: '',
      region: [],
      listQuery: {
        keyword: '',// 医生团队
        hospitalNameLike: '',// 线下机构
        serviceNameLike: '',// 服务名称
        current: 1,
        size: 10
      },
      type: '',
      
      total: 0,
      tableData: [],
      typeFormData: {},
    }
  },
  async created() {
    this.type = this.$store.state.userPlatForm === 'platForm' ? 'hospitalNameLike' : 'doctorTeamLike'
    await this.getInitData()
  },
  mounted() {},
  methods: {
    // async getQuestionData() {
    //   let { code, data } = await questionnaireDetails({
    //     id: this.paperId
    //   })
    //   if (code === 0) {
    //     this.quesData = data
    //   }
    // },
    typeChange(value) {
      this.listQuery = {
        doctorTeamLike: '',// 医生团队
        hospitalNameLike: '',// 线下机构
        serviceNameLike: '',// 服务名称
        current: 1,
        size: 10
      }
    },
    // 重置
    resetForm() {
      Object.assign(this.listQuery, {  keyword: '', current: 1, size: 10 })
    },
    handleClose() {
      this.$emit('update:showAddDoctor', false)
    },
    handleAdd(row) {
      this.$emit('receiveDoctor', row)
      this.$emit('update:showAddDoctor', false)
    },
    // 搜索
    async handleSearch() {
      Object.assign(this.listQuery, { ...this.listQuery, current: 1, size: 10 })
      this.getInitData()
    },
    async getInitData() {
      // 分页等待
      
      let { code, data: { records, total } } = await doctorTeamSearch({ ...this.listQuery,belongDataList:this.belongDataList})
      if (code === 0) {
        this.tableData = records;
        this.total = total
      }
    },
    handleSizeChange(val) {
      this.listQuery.size = val
      this.listQuery.current = 1
      this.getInitData()
    },
    handleCurrentChange(val) {
      this.listQuery.current = val
      this.getInitData()
    },
    
  }
}
</script>
<style lang="less" scoped>
// .list-question-wrap {
//   // height: 100%;
// }
/deep/.el-dialog__body {
  padding-top: 0px;
}
/deep/.el-dialog__header {
  padding-left: 35px;
}
.search-btns {
  margin-top: 5px;
}
.el-main {
    width: 100%;
    .main-content-list {
      height: 56vh;
      overflow: auto;
      padding: 15px;
      padding-top: 8px;
      background-color: #fff;
    }
}
.el-pagination {
  text-align: right;
  margin-top: 15px;
  margin-right: 40px;
}
.btn-bg {
  background:#1A7BFC;
  color: #fff;
}
.dialog-main-content {
  .dialog-title {
    font-size: 26px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
    margin-bottom: 8px;
    text-align: center;
    line-height: 2;
  }
  .pat-search {
    display: flex;
    .el-input {
      margin-left: 10px;
    }
  }
  .el-button {
    margin-left: 10px;
  }
}
/deep/.el-table td {
  padding: 6px 0;
}
</style>
